const types = {
    SET_HISTORY_LIST: '[HISTORY] SET HISTORY LIST',
}

export {
    types
}